module.exports = __webpack_public_path__ + "img/beesmart-logo.ce65d692.png";